import { AnyAction, Dispatch, Middleware } from 'redux';
import service from '../../service';
import type { RootState } from '../index';

const tracker: Middleware<unknown, RootState> = () => (next) => (action) => {
  const ret = next(action) as Dispatch;
  service.tracker.reduxActionListener(action as AnyAction);
  return ret;
};

export default tracker;
